
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import Head from 'next/head';
import { useCallback, useRef } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import Layout from '../../components/Layout';
import { createFormSchema, createRedirectIfNeeded, emailRule, Permalink, resetForm, validateForm } from '../../helpers';
import { Namespace } from 'enums';
import { getSharedApiClient } from '../../api/client';
import styles from '../login/index.module.scss';
import { basicSEO } from 'helpers/jsx';
import { useNotificationContext, useAuth } from 'context';
import { StaticPathParams } from 'typings/staticPaths';
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { useLang } from 'context/langContext';

interface Props {
  countryCode: string;
}

const ForgottenPassword: NextPage<Props> = ({ countryCode }) => {
  const auth = useAuth();
  const { t } = useTranslation(Namespace.ForgottenPassword);
  const { createNotification } = useNotificationContext();
  const ref = useRef<HTMLFormElement>(null);
  const serverError = useRef<HTMLLabelElement>(null);
  const router = useRouter();
  const { locale } = useLang();

  const RULE_NOT_EMPTY = t('common:form.not_empty');
  const RULE_WRONG_EMAIL = t('common:form.email_format');

  const onSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      event.stopPropagation();

      const formSchema = createFormSchema({
        email: emailRule(RULE_WRONG_EMAIL, RULE_NOT_EMPTY),
      });
      const email = (event.target as HTMLFormElement).email.value;
      const validateObject = {
        email,
      };
      const valid = validateForm(formSchema, validateObject, ref.current);
      if (valid) {
        try {
          await getSharedApiClient().resetPassword(email);
          router.push(Permalink.root(null, locale));
          createNotification({ title: t('changes_saved') });
        } catch (e) {
          resetForm(ref.current);
          createNotification({ title: t('changes_not_saved') });
          serverError.current.innerHTML = t('server_error');
        }
      } else {
        resetForm(ref.current);
      }
    },
    [auth],
  );
  return (
    <Layout countryCode={countryCode}>
      <Head>{basicSEO(t('seo:forgotten_password_title'), t('seo:forgotten_password_description'))}</Head>
      <main className={styles.login}>
        <div className={styles.loginWrapper}>
          <h1>{t('title')}</h1>
          <form ref={ref} onSubmit={onSubmit}>
            <label>
              {t('email')}
              <input type="text" placeholder={t('email_placeholder')} name="email" id="email" />
              <span></span>
            </label>
            <button type="submit" className="btn btn-primary">
              {t('btn')}
            </button>
            <label ref={serverError} className="server-error" id="server-error" htmlFor="email"></label>
          </form>
        </div>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, user, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  if (user) {
    return {
      redirect: {
        destination: Permalink.root(user, locale),
        permanent: false,
      },
    };
  }

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: { countryCode },
  };
}

export default ForgottenPassword;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/forgotten-password/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  